<template>
  <div class="class-list" v-if="orderInfo">
    <div class="case-title">
      <div class="icon_title">
        <div>
          <img
            class="case-title_icon"
            src="@/assets/images/imgAll/icon_smjy__.png"
            alt
          />
        </div>
        <div class="case-title_max">已接单</div>
        <div class="case-title_max" style="color: red">
          {{
            orderInfo.stateStamp == "01"
              ? "等待上门"
              : orderInfo.stateStamp == "02"
              ? "等待顾客到店"
              : orderInfo.stateStamp == "03"
              ? "未下回收单"
              : orderInfo.stateStamp == "04"
              ? "已下回收单"
              : orderInfo.stateStamp == "05"
              ? "已完成"
              : orderInfo.stateStamp == "06"
              ? "超时系统取消"
              : orderInfo.stateStamp == "07"
              ? "顾客取消"
              : orderInfo.stateStamp == "08"
              ? "员工操作取消"
              : orderInfo.stateStamp == "09"
              ? "回收单作废"
              : orderInfo.stateStamp == "10"
              ? "回收单退回"
              : "--"
          }}
        </div>
      </div>
    </div>
    <div style="padding: 0 20px">
      <span class="font_14"
        >线上估价单号：
        <span class="color_333 font_14">{{
          orderInfo.customerOrderNo
        }}</span></span
      >
      <span class="font_14" style="margin-left: 50px"
        >关联回收单号：<span
          @click="handleClick(orderInfo.recycleOrderNo)"
          style="cursor: pointer"
          :class="{ textdown: orderInfo.recycleOrderNo }"
          >{{ orderInfo.recycleOrderNo || "--" }}</span
        >
      </span>
      <div class="font_14" style="margin-top: 20px">
        下单时间：<span>{{ orderInfo.orderTime || "--" }}</span>
      </div>
    </div>
    <div class="case-title">
      <div class="icon_title">
        <div>
          <img
            class="case-title_icon"
            src="@/assets/images/imgAll/icon_zypz_@2x.png"
            alt
          />
        </div>
        <div class="case-title_max">顾客信息</div>
        <div class="tag">
          {{ orderInfo.recycleType == "01" ? "上门回收" : "到店回收" }}
        </div>
      </div>
    </div>
    <div class="userInfo" style="padding: 0 20px">
      <div>
        <img
          v-if="orderInfo.createHeadImg"
          style="width: 50px; height: 50px"
          :src="orderInfo.createHeadImg"
          alt=""
        />
        <span v-if="orderInfo.createNickName" class="font_16" style="font-weight: 600; margin-left: 10px;margin-right: 60px;">{{
          orderInfo.createNickName
        }}</span>
        <span class="font_14"
          >联系电话：<span>{{ orderInfo.createUserPhone || "--" }}</span></span
        >
        <span style="margin-left: 60px" class="font_14"
          >上门地址：<span>{{ orderInfo.userAddress || "--" }}</span></span
        >
      </div>
    </div>

    <div class="case-title">
      <div class="icon_title">
        <div>
          <img
            class="case-title_icon"
            src="@/assets/images/icon_detail_2.png"
            alt
          />
        </div>
        <div class="case-title_max">回收旧机信息</div>
        <div class="textdown" style="margin-left: 20px; text-decoration: none">
          接单人：{{ orderInfo.receiveStaffName }}-{{
            orderInfo.receiveStaffMobile
          }}
        </div>
        <div
          v-if="orderInfo.receiveStaffType"
          class="tag"
          style="background: #4eadf1; margin-left: 10px"
        >
          {{
            orderInfo.receiveStaffType == "03"
              ? "门店店长"
              : orderInfo.receiveStaffType == "04"
              ? " 普通职员"
              : "--"
          }}
        </div>
        <div class="textdown" style="margin-left: 20px; text-decoration: none">
          接单门店：{{ orderInfo.receiveStoreName || "--" }}
        </div>
        <div
          class="textdown"
          style="margin-left: 20px; text-decoration: none"
        ></div>
        <div class="textdown" style="margin-left: 20px; text-decoration: none">
          受理人：
          {{
            orderInfo.serveStaffName && orderInfo.serveStaffMobile
              ? `${orderInfo.serveStaffName}-${orderInfo.serveStaffMobile}`
              : "--"
          }}
        </div>
        <div
          v-if="orderInfo.serveStaffType"
          style="
            margin-left: 10px;
            font-size: 14px;
            padding: 0 5px;
            background: #4eadf1;
            color: #fff;
            border-radius: 5px;
            height: 20px;
            line-height: 20px;
          "
        >
          {{
            orderInfo.serveStaffType == "01"
              ? "子账号"
              : orderInfo.serveStaffType == "02"
              ? "总监"
              : orderInfo.serveStaffType == "03"
              ? "门店店长"
              : orderInfo.serveStaffType == "04"
              ? "普通"
              : "--"
          }}
        </div>
        <div class="textdown" style="margin-left: 20px; text-decoration: none">
          受理门店：{{ orderInfo.serveStoreName || "--" }}
        </div>
      </div>
    </div>

    <div style="padding: 0 20px">
      <el-table
        ref="tableGroup"
        :highlight-current-row="true"
        stripe
        :data="[info]"
        size="small"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="fenhaoCategoryName"
          label="旧机分类"
          align="center"
        >
          <template slot-scope="{ row }">
            <span class="colorblue">{{ row.fenhaoCategoryName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fenhaoBrandName" label="旧机品牌" align="center">
          <template slot-scope="{ row }">
            <span class="colorblue">{{ row.fenhaoBrandName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="旧机名称" align="center">
          <template slot-scope="{ row }">
            <span class="colorblue">{{ row.goodsName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="线上评估选项" align="center">
          <template>
            <span
              v-if="orderInfo.userFaults.length"
              class="textdown"
              style="cursor: pointer"
              @click="onlineCk()"
              >查看</span
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="线上评估价格" align="center">
          <template slot-scope="{ row }">
            <div class="colorblue">￥{{ row.userSubmitPrice || "--" }}</div>
            <div style="text-align: center;" v-if="row.userSubmitPriceType !=='01'&&row.leftSideUserSubmitPrice">
                  ({{ row.leftSideUserSubmitPrice||0 }}~{{ row.rightSideUserSubmitPrice||0 }})
                </div>
            <span
              class="textdown"
              style="cursor: pointer"
              @click="onlineOrderDialog = true"
              >查看明细</span
            >
          </template>
        </el-table-column>
        <el-table-column label="到店/上门评估选项" align="center">
          <!-- slot-scope="{ row }" -->
          <template>
            <span
              v-if="orderInfo.finalFaults.length"
              class="textdown"
              style="cursor: pointer"
              @click="Dialog = true"
              >查看</span
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="到店评估价格" align="center">
          <template slot-scope="{ row }">
            <div class="colorblue">{{ row.staffSubmitPrice || "--" }}</div>
            <div style="text-align: center;" v-if="row.userSubmitPriceType !=='01'&&row.leftSideStaffSubmitPrice">({{ row.leftSideStaffSubmitPrice }}~{{ row.rightSideStaffSubmitPrice }})</div>
            <span
              v-if="row.staffSubmitPrice"
              class="textdown"
              style="cursor: pointer"
              @click="salfOrderDialog = true"
              >查看明细</span
            >
          </template>
        </el-table-column>
        <!-- <el-table-column label="系统实际估价/商家配置估价" align="center">
          <template slot-scope="{ row }">
            <div class="colorblue">
              {{ row.fenhaoPrice || "--" }}/{{ row.companyFactorPrice || "--" }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="顾客回收价" align="center">
          <!-- slot-scope="{ row }" -->
          <template>
            <div class="colorblue">
              {{ orderInfo.recycleFinalPrice || 0 }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="case-title">
      <div class="icon_title">
        <div>
          <img
            class="case-title_icon"
            src="@/assets/images/icon_detail_1.png"
            alt
          />
        </div>
        <div class="case-title_max">订单状态</div>
      </div>
    </div>

    <div style="padding: 0 20px 20px">
      <div class="orderStatus">
        <div
          v-for="(item, index) in orderInfo.dynamicViews"
          :key="item.dynamicName"
        >
          <div
            class="color_333 font_18"
            style="
              font-weight: 600;
              margin-bottom: 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>{{ item.dynamicName }}</div>
            <div
              v-if="index + 1 != orderInfo.dynamicViews.length"
              class="line"
            ></div>
            <div
              v-if="index + 1 != orderInfo.dynamicViews.length"
              class="line_y"
            ></div>
          </div>
          <div class="font_14" v-if="item.dynamicName != '取消/退回'">
            {{
              item.dynamicName == "接单"
                ? "接单门店"
                : item.dynamicName == "到店"
                ? "服务门店"
                : item.dynamicName == "回收"
                ? "成交门店"
                : ""
            }}: <span>{{ item.storeName || "--" }}</span>
          </div>
          <div class="font_14" style="margin: 10px 0">
            {{
              item.dynamicName == "接单"
                ? "接单"
                : item.dynamicName == "到店"
                ? "确认"
                : item.dynamicName == "回收"
                ? "成交"
                : "取消/退回"
            }}时间: <span>{{ item.transferNo || "--" }}</span>
          </div>
          <div class="font_14">
            {{
              item.dynamicName == "接单"
                ? "接单人"
                : item.dynamicName == "到店"
                ? "服务店员"
                : item.dynamicName == "回收"
                ? "成交店员"
                : "取消/退回原因"
            }}:
            <span v-if="item.dynamicName != '取消/退回'">{{
              item.staffInfo || "--"
            }}</span>
            <span v-else>{{ item.storeName || "--" }}</span>
          </div>
          <div
            class="font_14"
            v-if="item.dynamicName == '取消/退回'"
            style="margin-top: 10px"
          >
            操作店员: <span>{{ item.staffInfo || "--" }}</span>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="线上评估信息"
      :visible.sync="refundTimeDialog"
      :close-on-click-modal="false"
      width="1200px"
      @closed="refundTimeDialog = false"
    >
      <div v-if="orderInfo">
        <span> 机型名称：{{ orderInfo.goodsName }} </span>
        <span style="margin-left: 30px"
          >线上预估金额：￥{{ orderInfo.userSubmitPrice || "--" }}
        </span>
        <div class="item_box">
          <div v-for="item in orderInfo.userFaults" :key="item.optionId">
            {{ item.optionKeyValueText }}：{{ item.optionValueText }}
          </div>
        </div>
      </div>
      <!-- <el-input
        v-model="formData.remark"
        placeholder="请输入谷歌动态验证码"
      ></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="refundTimeDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="实际评估信息"
      :visible.sync="Dialog"
      :close-on-click-modal="false"
      width="1200px"
      @closed="Dialog = false"
    >
      <div v-if="orderInfo">
        <span> 机型名称：{{ orderInfo.goodsName }} </span>
        <div class="item_box">
          <div v-for="item in orderInfo.finalFaults" :key="item.optionId">
            {{ item.optionKeyValueText }}：{{ item.optionValueText }}
          </div>
        </div>
      </div>
      <!-- <el-input
        v-model="formData.remark"
        placeholder="请输入谷歌动态验证码"
      ></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="Dialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="线上评估价格明细"
      :visible.sync="onlineOrderDialog"
      :close-on-click-modal="false"
      width="500px"
      @closed="onlineOrderDialog = false"
    >
      <div v-if="orderInfo">
        <div style="margin-bottom: 10px">
          商家评估价/系统评估价：{{
            orderInfo.assessOrderInfoViews[0].companyFactorPrice || "--"
          }}/{{ orderInfo.assessOrderInfoViews[0].fenhaoPrice || "--" }}
        </div>
        <span
          >扣减公司利润：{{
            orderInfo.assessOrderInfoViews[0] &&
            orderInfo.assessOrderInfoViews[0].allCompanyRebate
              ? orderInfo.assessOrderInfoViews[0].allCompanyRebate
              : "--"
          }}</span
        >
        <span style="margin-left: 120px"
          >扣减员工红包：{{
            orderInfo.assessOrderInfoViews[0] &&
            orderInfo.assessOrderInfoViews[0].allStaffReward
              ? orderInfo.assessOrderInfoViews[0].allStaffReward
              : "--"
          }}</span
        >
        <div style="margin-top: 10px">
          顾客评估价：{{
            orderInfo.assessOrderInfoViews[0]
              ? orderInfo.assessOrderInfoViews[0].initShowPrice
              : "--"
          }}（本机估价{{
            orderInfo.assessOrderInfoViews[0]
              ? orderInfo.assessOrderInfoViews[0].localMachinePrice
              : "--"
          }}
          + 限时红包{{
            orderInfo.assessOrderInfoViews[0]
              ? orderInfo.assessOrderInfoViews[0].showReward
              : "--"
          }}）
        </div>
        <div style="margin-top: 10px; color: #0981ff">
          线上评估价：{{
            orderInfo.assessOrderInfoViews[0].submitPrice || "0"
          }}
          = 本机估价{{
            orderInfo.assessOrderInfoViews[0]
              ? orderInfo.assessOrderInfoViews[0].localMachinePrice
              : "0"
          }}
          + 限时红包{{
            orderInfo.assessOrderInfoViews[0]
              ? orderInfo.assessOrderInfoViews[0].showReward
              : "0"
          }}
          + 积分加价{{
            orderInfo.assessOrderInfoViews[0]
              ? orderInfo.assessOrderInfoViews[0].usePoints
              : "0"
          }}
        </div>
      </div>
      <!-- <el-input
        v-model="formData.remark"
        placeholder="请输入谷歌动态验证码"
      ></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          @click="onlineOrderDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="店员确认评估价格明细"
      :visible.sync="salfOrderDialog"
      :close-on-click-modal="false"
      width="500px"
      @closed="salfOrderDialog = false"
    >
      <div v-if="orderInfo && orderInfo.assessOrderInfoViews[1]">
        <div style="margin-bottom: 10px">
          商家评估价/系统评估价：{{
            orderInfo.assessOrderInfoViews[1].companyFactorPrice || "--"
          }}/{{ orderInfo.assessOrderInfoViews[1].fenhaoPrice || "--" }}
        </div>
        <span
          >扣减公司利润：{{
            orderInfo.assessOrderInfoViews[1] &&
            orderInfo.assessOrderInfoViews[1].allCompanyRebate
              ? orderInfo.assessOrderInfoViews[1].allCompanyRebate
              : "--"
          }}</span
        >
        <span style="margin-left: 120px"
          >扣减员工红包：{{
            orderInfo.assessOrderInfoViews[1] &&
            orderInfo.assessOrderInfoViews[1].allStaffReward
              ? orderInfo.assessOrderInfoViews[1].allStaffReward
              : "--"
          }}</span
        >
        <div style="margin-top: 10px">
          顾客评估价：{{
            orderInfo.assessOrderInfoViews[1]
              ? orderInfo.assessOrderInfoViews[1].initShowPrice
              : "--"
          }}（本机估价{{
            orderInfo.assessOrderInfoViews[1]
              ? orderInfo.assessOrderInfoViews[1].localMachinePrice
              : "--"
          }}
          + 限时红包{{
            orderInfo.assessOrderInfoViews[1]
              ? orderInfo.assessOrderInfoViews[1].showReward
              : "--"
          }}）
        </div>
        <div style="margin-top: 10px; color: #0981ff">
          线上评估价：{{
            orderInfo.assessOrderInfoViews[1].submitPrice || "0"
          }}
          = 本机估价{{
            orderInfo.assessOrderInfoViews[1]
              ? orderInfo.assessOrderInfoViews[1].localMachinePrice
              : "0"
          }}
          + 限时红包{{
            orderInfo.assessOrderInfoViews[1]
              ? orderInfo.assessOrderInfoViews[1].showReward
              : "0"
          }}
          + 积分加价{{
            orderInfo.assessOrderInfoViews[1]
              ? orderInfo.assessOrderInfoViews[1].usePoints
              : "0"
          }}
        </div>
      </div>
      <!-- <el-input
        v-model="formData.remark"
        placeholder="请输入谷歌动态验证码"
      ></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="salfOrderDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "class-list",

  data() {
    return {
      orderInfo: null,
      info: {},
      refundTimeDialog: false,
      Dialog: false,
      onlineOrderDialog: false,
      salfOrderDialog: false,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      _api
        .assessOrderInfo({ customerOrderNo: this.$route.query.orderNo })
        .then((res) => {
          this.orderInfo = res.data;
          this.info = {...res.data}
          // {
          //   fenhaoCategoryName: res.data.fenhaoCategoryName,
          //   fenhaoBrandName: res.data.fenhaoBrandName,
          //   goodsName: res.data.goodsName,
          //   userSubmitPrice: res.data.userSubmitPrice, //线上评估价格
          //   staffSubmitPrice: res.data.staffSubmitPrice,
          //   fenhaoPrice: res.data.fenhaoPrice, //系统实际估价
          //   companyFactorPrice: res.data.companyFactorPrice, //商家配置估价
          //   initShowPrice: res.data.initShowPrice, //顾客回收价
          // };
        });
    },
    onlineCk() {
      this.refundTimeDialog = true;
    },
    handleClick(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.class-list {
  background: #fff;
  .case-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .icon_title {
      display: flex;

      .case-title_icon {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }

      .case-title_max {
        display: inline-block;
        height: 17px;
        font-size: 16px;
        font-family: FZLanTingHei-B-GBK;
        font-weight: 600;
        color: #333333;
        line-height: 22px;
        margin-right: 10px;
      }
    }
  }
  .item_box {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    > div:not(:last-child) {
      margin-right: 16px;
    }
    > div {
      width: 370px;
      min-height: 40px;

      border: 1px solid #333;
      // line-height: 40px;
      padding: 0 10px;
      box-sizing: border-box;
      margin-top: 10px;
      display: flex;
      align-items: center;
      // word-break: keep-all;
      // white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
    }
  }
  .textdown {
    color: #0981ff;
    text-decoration: underline;
  }
  .colorblue {
    color: #0981ff;
  }
  .font_14 {
    font-size: 14px;
  }
  .font_16 {
    font-size: 16px;
  }
  .font_18 {
    font-size: 18px;
  }
  .color_ccc {
    color: #ccc;
  }
  .color_eee {
    color: #eee;
  }
  .color_333 {
    color: #333;
  }
  .tag {
    padding: 0 5px;
    background: #ff8800;
    height: 20px;
    color: #fff;
    border-radius: 10px 10px 10px 0;
    font-size: 14px;
    text-align: center;
    line-height: 20px;
  }
  .userInfo {
    > div {
      border-radius: 10px;
      display: flex;
      align-items: center;
      background: #f5f6fa;
      padding: 20px;
    }
  }
  .orderStatus {
    display: flex;
    align-items: center;
    background: #f5f6fa;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    .line {
      width: 250px;
      height: 2px;
      background: #0981ff;
      margin-left: 10px;
    }
    .line_y {
      height: 10px;
      width: 10px;
      border-radius: 50%;
      background: #0981ff;
      margin-right: 10px;
    }
  }
}
</style>
